module.exports = __webpack_public_path__ + "assets/img/new_products.2494ce16.png";